import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule  } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UserInfo } from '../userinfo';
import { AuthorizationService } from '../services/authorization.service';
import { TokenResponse } from '@openid/appauth';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    styles: [`
    #main-menu {
      display: none;
    }
  `],
})
export class LoginComponent implements OnInit {
    public authorized: boolean;
    loginForm: FormGroup;
    submitted: boolean = false;

    invalid: boolean = false;
    public userInfo: UserInfo | null;
    usermodel: any = {};
    isError: boolean = false;
    returnUrl: string = '';
    loading = false;
    languages: any[];
    signintext: string = 'SIGN IN';
    isPageLoad: boolean = false;
    isPageSwitch: boolean = false;
    userRights_data: any;
    constructor(private formBuilder: FormBuilder, public router: Router,private authorizationService: AuthorizationService){}
    //public isVisible = false;
    //public isVisible: boolean = null;
    isHidden: boolean = true;

    ngOnInit() 
    {        
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });       
        console.log(this.isHidden); //console shows true

        this.authorizationService.userInfos().subscribe((userInfo: UserInfo) => {
            this.userInfo = userInfo;
        });
        this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse) => {
            this.authorized = tokenResponse != null;
        });

        console.log("start");
        this.Authorize();
        console.log("end");
    }

    Authorize() {
        this.authorizationService.authorize();
        this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse) => {
            this.authorized = tokenResponse != null;
            if (this.authorized) {
                let that=this;
                setTimeout(function(){ that.router.navigate(['/home/AppCatalog']); }, 1000);
                //this.router.navigate(['AppCatalog']);
            }
        });
        /*if (this.authorized) {
            this.router.navigate(['AppCatalog']);
        }*/
    }

    get f() { return this.loginForm.controls; }
    
    onSubmit() 
    {}   
}